<template>
  <div>
    <div class="main-content card" v-if="loader === 100">
      <div class="card-header">
        <h4 class="card-title">
          <i class="fas fa-chart-line"></i> Relatório de Produtividade por
          Operador
        </h4>
      </div>
      <div class="card-body">
        <div class="row">
          <!-- Filtro de Operador -->
          <div class="col-md-3">
            <label><b>Operador</b></label>
            <v-select
              v-model="filtros.user_id"
              :options="operadores"
              :reduce="(operador) => operador.id"
              label="name"
              placeholder="Todos os operadores"
            >
              <template #no-options> Nenhum operador encontrado </template>
            </v-select>
          </div>

          <!-- Filtro de Setor -->
          <div class="col-md-3">
            <label><b>Setor</b></label>
            <v-select
              v-model="filtros.setor_id"
              :options="setores"
              :reduce="(setor) => setor.id"
              label="nome"
              placeholder="Todos os setores"
            >
              <template #no-options> Nenhum setor encontrado </template>
            </v-select>
          </div>

          <!-- Data Inicial -->
          <div class="col-md-2">
            <label><b>Data Inicial</b></label>
            <input
              type="date"
              class="form-control"
              v-model="filtros.data_inicio"
            />
          </div>

          <!-- Data Final -->
          <div class="col-md-2">
            <label><b>Data Final</b></label>
            <input
              type="date"
              class="form-control"
              v-model="filtros.data_fim"
            />
          </div>

          <!-- Botões de Ação -->
          <div class="col-md-2">
            <br />
            <button
              class="btn btn-primary btn-block"
              @click="buscarRelatorio()"
            >
              <i class="fas fa-search"></i> Buscar
            </button>
          </div>
        </div>

        <!-- Botões de Atalho de Período -->
        <div class="row mt-3">
          <div class="col-md-12">
            <button
              class="btn btn-sm btn-outline-secondary mr-2"
              @click="setHoje()"
            >
              Hoje
            </button>
            <button
              class="btn btn-sm btn-outline-secondary mr-2"
              @click="setUltimos7Dias()"
            >
              Últimos 7 dias
            </button>
            <button
              class="btn btn-sm btn-outline-secondary mr-2"
              @click="setUltimos30Dias()"
            >
              Últimos 30 dias
            </button>
            <button
              class="btn btn-sm btn-outline-secondary mr-2"
              @click="setMesAtual()"
            >
              Mês Atual
            </button>
          </div>
        </div>

        <hr />

        <!-- Botão de Exportar Excel -->
        <div class="row mb-3" v-if="relatorio.length > 0">
          <div class="col-md-12 text-right">
            <button class="btn btn-success" @click="exportarExcel()">
              <i class="fas fa-file-excel"></i> Exportar para Excel
            </button>
          </div>
        </div>

        <!-- Tabela de Resultados -->
        <div class="row" v-if="relatorio.length > 0">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-bordered table-striped table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">#</th>
                    <th>Operador</th>
                    <th>E-mail</th>
                    <th v-if="filtros.setor_id">Setor</th>
                    <th class="text-center">Total de Senhas Atendidas</th>
                    <th class="text-center">Tempo Médio de Atendimento</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in relatorio"
                    :key="item.operador_id + '_' + (item.setor_nome || '')"
                  >
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ item.operador_nome }}</td>
                    <td>{{ item.operador_email }}</td>
                    <td v-if="filtros.setor_id">
                      <span class="badge badge-secondary">
                        {{ item.setor_nome }}
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="badge badge-primary badge-pill">
                        {{ item.total_senhas_atendidas }}
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="badge badge-info">
                        {{ item.tempo_medio_atendimento }}
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="bg-light font-weight-bold">
                    <td :colspan="filtros.setor_id ? 4 : 3" class="text-right">
                      TOTAL:
                    </td>
                    <td class="text-center">
                      <span class="badge badge-success badge-pill">
                        {{ totalSenhas }}
                      </span>
                    </td>
                    <td class="text-center">-</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <!-- Mensagem quando não há resultados -->
        <div class="row" v-else-if="buscaRealizada">
          <div class="col-12">
            <div class="alert alert-warning text-center">
              <i class="fas fa-info-circle"></i>
              Nenhum resultado encontrado para os filtros aplicados.
            </div>
          </div>
        </div>

        <!-- Mensagem inicial -->
        <div class="row" v-else>
          <div class="col-12">
            <div class="alert alert-info text-center">
              <i class="fas fa-info-circle"></i>
              Selecione os filtros desejados e clique em
              <strong>Buscar</strong> para visualizar o relatório.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div class="main-content" v-else>
      <div class="card">
        <div class="card-body text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
          <p class="mt-2">Carregando dados...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      loader: 0,
      operadores: [],
      setores: [],
      relatorio: [],
      filtrosAplicados: {},
      buscaRealizada: false,
      filtros: {
        user_id: null,
        setor_id: null,
        data_inicio: null,
        data_fim: null,
      },
    };
  },
  computed: {
    totalSenhas() {
      return this.relatorio.reduce((total, item) => {
        return total + parseInt(item.total_senhas_atendidas);
      }, 0);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$loading(true);
      this.carregarOperadores();
      this.carregarSetores();
      this.setUltimos7Dias();
      this.loader = 100;
      this.$loading(false);
    },

    carregarOperadores() {
      const api = this.$store.state.api + "users?paginated=false";

      axios
        .get(api)
        .then((response) => {
          // Carregar todos os usuários
          this.operadores = response.data.data;
        })
        .catch((error) => {
          this.$message(null, "Erro ao carregar operadores", "error");
          console.error(error);
        });
    },

    carregarSetores() {
      const api = this.$store.state.api + "setores?paginated=false";

      axios
        .get(api)
        .then((response) => {
          // Carregar todos os setores
          this.setores = response.data.data;
        })
        .catch((error) => {
          this.$message(null, "Erro ao carregar setores", "error");
          console.error(error);
        });
    },

    buscarRelatorio() {
      this.$loading(true);
      const api = this.$store.state.api + "relatorio-produtividade";

      const params = {};
      if (this.filtros.user_id) params.user_id = this.filtros.user_id;
      if (this.filtros.setor_id) params.setor_id = this.filtros.setor_id;
      if (this.filtros.data_inicio)
        params.data_inicio = this.filtros.data_inicio;
      if (this.filtros.data_fim) params.data_fim = this.filtros.data_fim;

      axios
        .get(api, { params })
        .then((response) => {
          this.relatorio = response.data.data;
          this.filtrosAplicados = response.data.filtros_aplicados;
          this.buscaRealizada = true;

          if (this.relatorio.length === 0) {
            this.$message(
              "Aviso",
              "Nenhum resultado encontrado para os filtros aplicados.",
              "warning"
            );
          } else {
            this.$message(
              "Sucesso",
              `${this.relatorio.length} registro(s) encontrado(s).`,
              "success"
            );
          }
        })
        .catch((error) => {
          this.$message(null, "Erro ao buscar relatório", "error");
          console.error(error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    exportarExcel() {
      this.$loading(true);
      const api = this.$store.state.api + "relatorio-produtividade/excel";

      const params = {};
      if (this.filtros.user_id) params.user_id = this.filtros.user_id;
      if (this.filtros.setor_id) params.setor_id = this.filtros.setor_id;
      if (this.filtros.data_inicio)
        params.data_inicio = this.filtros.data_inicio;
      if (this.filtros.data_fim) params.data_fim = this.filtros.data_fim;

      axios
        .get(api, {
          params,
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `relatorio_produtividade_${new Date().getTime()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          link.remove();

          this.$message(
            "Sucesso",
            "Relatório exportado com sucesso!",
            "success"
          );
        })
        .catch((error) => {
          this.$message(null, "Erro ao exportar relatório", "error");
          console.error(error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    // Métodos de atalho de período
    setHoje() {
      const hoje = new Date().toISOString().split("T")[0];
      this.filtros.data_inicio = hoje;
      this.filtros.data_fim = hoje;
    },

    setUltimos7Dias() {
      const hoje = new Date();
      const setesDiasAtras = new Date(hoje);
      setesDiasAtras.setDate(hoje.getDate() - 7);

      this.filtros.data_inicio = setesDiasAtras.toISOString().split("T")[0];
      this.filtros.data_fim = hoje.toISOString().split("T")[0];
    },

    setUltimos30Dias() {
      const hoje = new Date();
      const trintaDiasAtras = new Date(hoje);
      trintaDiasAtras.setDate(hoje.getDate() - 30);

      this.filtros.data_inicio = trintaDiasAtras.toISOString().split("T")[0];
      this.filtros.data_fim = hoje.toISOString().split("T")[0];
    },

    setMesAtual() {
      const hoje = new Date();
      const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

      this.filtros.data_inicio = primeiroDia.toISOString().split("T")[0];
      this.filtros.data_fim = hoje.toISOString().split("T")[0];
    },
  },
};
</script>

<style scoped>
.badge-pill {
  font-size: 14px;
  padding: 8px 12px;
}

.table thead th {
  vertical-align: middle;
}

.btn-block {
  margin-top: 0;
}

/* Dark Mode Support */
.dark-layout .table {
  background: #283046;
  color: #d0d2d6;
}

.dark-layout .table thead th {
  background: #161d31;
  color: #d0d2d6;
  border-color: #3b4253;
}

.dark-layout .table tbody tr {
  border-color: #3b4253;
}

.dark-layout .table tbody td {
  border-color: #3b4253;
  color: #d0d2d6;
}

.dark-layout .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.02);
}

.dark-layout .table-hover tbody tr:hover {
  background-color: #161d31;
}
</style>
